import Header from "./Header";
import Section from "./Section";
import Footer from "./Footer";


const Main = () => {
    return ( 
        <main className="max-w-sm md:max-w-lg lg:max-w-[75.33rem] xl:max-w-[80rem]">
            <Header />
            <Section />
            <Footer />
        </main>
     );
}
 
export default Main;